import Vue from "vue";
import Router from "vue-router";
import loginUtil from "@/util/loginUtil";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { mainMenu, mainNotMenu, notMain } from "./routerBuilder";

Vue.use(Router);

const routes = [
  notMain("登录", "login", "main/Login"),
  notMain("订单详情", "salesOrder/:orderId", "SalesOrder/OrderDetails"),
  notMain("发货单详情", "deliveryBill/:billId", "DeliveryManage/SapDeliveryBillDetails"),
  notMain("商务申请详情", "BusinessApplicationDetail/:businessApplicationID", "SalesManage/businessApplication/BusinessApplicationDetail"),
  mainMenu("首页", "home", [{ title: "首页", name: "Home", path: "/", componentPath: "main/Home", authIndex: 0 }]),
  mainNotMenu([{ title: "页面刷新", path: "/redirect/:path*", componemntPath: "redirect/Redirect", authIndex: 0 }]),
  mainNotMenu([
    {
      title: "商务申请预览",
      name: "BusinessApplicationPreview",
      path: "/businessApplication",
      componentPath: "SalesManage/businessApplication/BusinessApplicationPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "新建商务申请",
      name: "BusinessApplicationAdd",
      path: "/businessApplicationAdd",
      componentPath: "SalesManage/businessApplication/BusinessApplicationAdd",
      authIndex: 0,
    },
  ]),
  mainNotMenu([{ title: "审批_", name: "Approval", path: "/approval", componentPath: "workFlow/Approval", authIndex: 0 }]),
  mainNotMenu([
    {
      title: "销售订单预览",
      name: "SalesOrderPreview",
      path: "/salesOrder",
      componentPath: "SalesManage/SalesOrder/SalesOrderPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "销售订单编辑",
      name: "SalesOrderEdit",
      path: "/salesOrderEdit",
      componentPath: "SalesManage/SalesOrder/SalesOrderEdit",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "生产工单预览",
      name: "ProductionOrderPreview",
      path: "/productionOrderPreview",
      componentPath: "ProductionManagement/ProductionOrder/ProductionOrderPreview",
      authIndex: 0,
    },
  ]),
  // 工作流(workFlow)
  mainMenu("工作流", "workFlow", [
    { title: "销售订单", name: "SalesOrderApplication", componentPath: "workFlow/SalesOrderApplication", authIndex: 316 },
    { title: "发货通知单", name: "DeliveryNoteApplication", componentPath: "workFlow/DeliveryNoteApplication", authIndex: 475 },
    { title: "商务申请", name: "BusinessApplication", componentPath: "workFlow/BusinessApplication", authIndex: 0 },
    { title: "ESOP变更申请", name: "EsopFileApplication", componentPath: "workFlow/EsopFileApplication", authIndex: 400 },
    { title: "新产品申请待办", name: "ProductionApplication", componentPath: "workFlow/ProductionApplication", authIndex: 613 },
    { title: "客诉申请待办", name: "WfReplacementBillApplication", componentPath: "workFlow/ReplacementBillApplication", authIndex: 608 },
    { title: "来料NG待办", name: "PurchaseNgApplication", componentPath: "workFlow/PurchaseNgApplication", authIndex: 618 },
    { title: "首检巡检NG待办", name: "ProductNgApplication", componentPath: "workFlow/ProductNgApplication", authIndex: 623 },
    { title: "供应商申请待办", name: "SupplierApplication", componentPath: "workFlow/SupplierApplication", authIndex: 652 },
  ]),
  // 销售管理(salesManage)
  mainMenu("销售管理", "salesManage", [
    { title: "商务申请", name: "BusinessApplicationList", componentPath: "SalesManage/businessApplication/BusinessApplicationList", authIndex: 301},
    { title: "销售订单", name: "SalesOrderList", componentPath: "SalesManage/SalesOrder/SalesOrderList", authIndex: 3 },
    { title: "销售订单明细", name: "SalesOrderDetailList", componentPath: "SalesManage/SalesOrder/SalesOrderDetailList", authIndex: 242 },
    { title: "客户采购订单", name: "CustomerPurchaseOrderList", componentPath: "SalesManage/CustomerPurchaseOrder/CustomerPurchaseOrderList", authIndex: 321},
    { title: "销售订单待发货", name: "SalesOrderDetailUnDeliveryList", componentPath: "SalesManage/SalesOrder/SalesOrderDetailUnDeliveryList", authIndex: 292 },
    { title: "发货通知单", name: "DeliveryNoticeList", componentPath: "SalesManage/DeliveryNotice/DeliveryNoticeList", authIndex: 292},
    { title: "发货通知单明细", name: "DeliveryNoticeDetailList", componentPath: "SalesManage/DeliveryNotice/DeliveryNoticeDetailList", authIndex: 462},
  ]),
  mainMenu("统计分析","ReportManagement",[
      { title: "客户销售发货报表", name: "CustomerSalesReport", componentPath: "Report/SalesReport/CustomerSalesReport", authIndex: 466 },
      { title: "工单准时率报表", name: "ProductReport", componentPath: "Report/ProductReport/WorkOrderPunctualityReport", authIndex: 467 },
      { title: "检验准时率报表", name: "InspectionRpt", componentPath: "Report/InspectionRpt/InspectionRpt", authIndex: 468 },
      { title: "采购准时率报表", name: "PurchaseRpt", componentPath: "Report/PurchaseRpt/PurchasePunctualityReport", authIndex: 469 },
      { title: "产线节点报表", name: "ProcessRpt", componentPath: "Report/ProcessRpt/ProcessRpt", authIndex: 486 },
      { title: "产线时间明细报表", name: "ProcessDetailRpt", componentPath: "Report/ProcessRpt/ProcessDetailRpt", authIndex: 488 },
      { title: "仓库收发料报表", name: "StockRpt", componentPath: "Report/StockRpt/StockRpt", authIndex: 487 },
    ]),
  // 生产管理(ProductionManagement)
  mainMenu("生产管理", "ProductionManagement", [
    { title: "生产工单", name: "ProductionPlanList", componentPath: "ProductionManagement/ProductionPlan/ProductionPlanList", authIndex: 12 },
    { title: "生产排产", name: "ProductionOrderList", componentPath: "ProductionManagement/ProductionOrder/ProductionOrderList", authIndex: 18 },
    { title: "生产任务", name: "ProductionTaskList", componentPath: "ProductionManagement/ProductionTask/ProductionTaskList", authIndex: 359 },
    { title: "生产计划", name: "ProductionProjectList", componentPath: "ProductionManagement/ProductionProject/ProductionProject", authIndex:403 },
    { title: "生产条码记录", name: "ProductionCodeList", componentPath: "ProductionManagement/ProductionCode/ProductionCodeList", authIndex:403 },
    { title: "扫描工序记录", name: "ProductionProcessList", componentPath: "ProductionManagement/ProductionProcess/ProductionProcessList", authIndex:403 },
    { title: "生产过程扫描", name: "ProductionScanIndex", componentPath: "ProductionManagement/ProductionScan/ProductionScanIndex", authIndex: 359 },
    { title: "上料验证扫描", name: "LoadMaterialScanIndex", componentPath: "ProductionManagement/LoadMaterialScan/LoadMaterialScanIndex", authIndex: 25 },
    { title: "批量生产扫描", name: "PlFinishScanIndex", componentPath: "ProductionManagement/PlFinishScan/PlFinishScanIndex" },
    { title: "生产检验扫描", name: "CheckOutScan", componentPath: "ProductionManagement/CheckOutScan/CheckOutScan" },
    { title: "生产下料扫描", name: "ProductionBlank", componentPath: "ProductionManagement/ProductionBlankScan/ProductionBlankScan" },
    { title: "喷涂链位扫描", name: "SprayScan", componentPath: "ProductionManagement/SprayScan/SprayScan" },
    { title: "线边库存明细", name: "LineLocationList", componentPath: "ProductionManagement/LineLocation/LineLocationList" },
  ]),
  mainMenu("标签管理", "LabelPrinting", [
    { title: "物料标签管理", name: "MaterialLabelPrinting", componentPath: "MaterialLabel/MaterialLabelTabs", authIndex: [722,731,736,753] },
    { title: "标签打印", name: "LabelPrinting", componentPath: "LabelPrinting/LabelPrintingPage", authIndex: 382 },
    { title: "初始化标签打印", name: "InitPrinting", componentPath: "LabelPrinting/MaterialInitializationLabelPrinting", authIndex: 386 },
    { title: "生产标签打印", name: "LabelPrintingPageTaskOrder", componentPath: "LabelPrinting/LabelPrintingPageTaskOrder", authIndex: 485 },
  ]),
  mainMenu("质量管理","qm",[
    { title: "测试记录", name: "InspectionTestList", componentPath: "qm/InspectionTest/InspectionTestList", authIndex: 641 },
    { title: "标准检验模板", name: "TemplateManagementList", componentPath: "qm/MaterialTemplate/MaterialTemplateList", authIndex: 439 },
    { title: "来料检验模板", name: "PurchaseTemplateList", componentPath: "qm/PurchaseTemplate/PurchaseTemplateList", authIndex: 516 },
    { title: "首件检验模板", name: "ProductTemplateList1", componentPath: "qm/ProductTemplate1/ProductTemplateList1", authIndex: 627 },
    { title: "巡检检验模板", name: "ProductTemplateList2", componentPath: "qm/ProductTemplate2/ProductTemplateList2", authIndex: 631 },
    { title: "检验项", name: "InspectionItemList", componentPath: "information/Inspection/InspectionItemList", authIndex: 433 },
    { title: "来料检验表", name: "PurchaseReportList", componentPath: "qm/PurchaseReport/PurchaseReportList", authIndex: 446 },
    { title: "首件检验表", name: "InspectionReportList", componentPath: "qm/InspectionReport/InspectionReportList", authIndex: 521 },
    { title: "巡检检验表", name: "PurchaseReportList1", componentPath: "qm/InspectionReport1/InspectionReportList1", authIndex: 528 },
    { title: "来料NG", name: "PurchaseNgList", componentPath: "qm/PurchaseNg/PurchaseNgList", authIndex: 615 },
    { title: "首检巡检NG", name: "ProductNgList", componentPath: "qm/ProductNg/ProductNgList", authIndex: 620 },
  ]),
  mainMenu("治具管理", "ToolManagement", [
    { title: "治具类型管理", name: "ToolType", componentPath: "information/ToolManagement/ToolType/ToolTypeTree", authIndex: 472 },
    { title: "治具档案", name: "Tool", componentPath: "information/ToolManagement/Tool/ToolList", authIndex: 472 },
    { title: "治具领用记录", name: "ToolRequisitionBill", componentPath: "information/ToolManagement/ToolRequisitionBill/ToolRequisitionBillList", authIndex: 472 },
  ]),
  //发运管理
  mainMenu("发运管理", "DeliveryManagement", [
    { title: "销售出库", name: "MmDeliveryDetailList", componentPath: "DeliveryManage/MmDeliveryDetailList", authIndex: 298 },
    { title: "销售出库待办", name: "MmDeliveryDetailUnHandleList", componentPath: "DeliveryManage/MmDeliveryDetailUnHandleList", authIndex: 298 },
    { title: "装箱清单", name: "PackMarkDetailList", componentPath: "DeliveryManage/PackMark/PackMarkDetailList", authIndex: 743 },
    ]),
  mainMenu("售后管理", "csm", [
    { title: "客诉申请", name: "ReplacementBillList", componentPath: "csm/ReplacementBill/ReplacementBillList", authIndex: 604 },
  ]),
  // 仓库管理
  mainMenu("仓库管理", "StoreManagement", [
    { title: "扫描记录", name: "ScanRecordList", componentPath: "StoreManagement/ScanRecord/ScanRecordList", authIndex: 540 },
    { title: "库存明细", name: "InventoryList", componentPath: "StoreManagement/Inventory/InventoryList", authIndex: 31 },
    { title: "发货通知单待办", name: "DeliveryNoticeDetailUnHandleList", componentPath: "StoreManagement/UnHandleDelivery/DeliveryNoticeDetailUnHandleList", authIndex: 482},
    // { title: "销售出库", name: "OutStockDeliveryList", componentPath: "StoreManagement/OutStockDelivery/OutStockDeliveryList", authIndex: 298 },
    { title: "销售出库", name: "OutStockDeliveryDetailList", componentPath: "StoreManagement/OutStockDelivery/OutStockDeliveryDetailList", authIndex: 298 },
    { title: "出库订单", name: "OutStockOrderList", componentPath: "StoreManagement/OutStockOrder/OutStockOrderList", authIndex: 42 },
    { title: "出库单扫描", name: "OutStoreScanIndex", componentPath: "StoreManagement/OutStoreScan/OutStoreScanList", authIndex: 52 },
    { title: "生产领料", name: "ProductionPickingList", componentPath: "StoreManagement/ProductionPicking/ProductionPickingList", authIndex: 33},
    { title: "调拨领料", name: "TransferPickingList", componentPath: "StoreManagement/OutStockTransferPicking/OutStockTransferPickingList", authIndex: 420},
    { title: "领料出库扫描", name: "OutStockTransferScanIndex", componentPath: "StoreManagement/OutStockTransferScan/OutStockTransferScanList", authIndex: 407 },
    { title: "领料确认扫描", name: "OutStockTransferScanConfirmIndex", componentPath: "StoreManagement/OutStockTransferScan/OutStockTransferScanConfirm", authIndex: 408 },
    { title: "生产退料", name: "ProductionReturnList", componentPath: "StoreManagement/ProductionReturn/ProductionReturnList", authIndex: 371},
    { title: "领料单退料",name: "PickingReturnList", componentPath: "StoreManagement/PickingReturn/PickingReturnList", authIndex: 412},
    { title: "退料出库扫描", name: "OutStockTransferBackScanIndex", componentPath: "StoreManagement/OutStockTransferBackScan/OutStockTransferBackScanList", authIndex: 409 },
    { title: "退料确认扫描", name: "OutStockTransferBackScanConfirmIndex", componentPath: "StoreManagement/OutStockTransferBackScan/OutStockTransferBackScanConfirm", authIndex: 410 },
    // {
    //   title: "工单发料",
    //   name: "WorkOrderStoreIssue",
    //   componentPath: "StoreManagement/WorkOrderStoreIssue/WorkOrderStoreIssueList",
    //   authIndex: 54,
    // },
    // {
    //   title: "工单发料扫描",
    //   name: "WorkOrderStoreIssueScan",
    //   componentPath: "StoreManagement/WorkOrderStoreIssueScan/WorkOrderStoreIssueScanList",
    //   authIndex: 56,
    // },
    { title: "采购收货", name: "PurchaseReceivingList", componentPath: "StoreManagement/PurchaseReceiving/PurchaseReceivingIndex", authIndex: 58},
    { title: "采购收货明细", name: "PurchaseReceivingDetailList", componentPath: "StoreManagement/PurchaseReceivingDetail/PurchaseReceivingDetail", authIndex: 93},
    { title: "收货扫描", name: "ReceivingScanIndex", componentPath: "StoreManagement/ReceivingScan/ReceivingScanList", authIndex: 68 },
    // {
    //   title: "生产入库",
    //   name: "ProductionStorage",
    //   componentPath: "StoreManagement/ProductionStorage/ProductionStorageIndex",
    //   authIndex: 70,
    // },
    { title: "入库订单", name: "StorageOrderList", componentPath: "StoreManagement/StorageOrder/StorageOrderIndex", authIndex: 80 },
    { title: "入库单扫描", name: "StoreScanIndex", componentPath: "StoreManagement/StoreScan/StoreScanList", authIndex: 89 },
    { title: "生产入库扫描", name: "ProductionStoreScanIndex", componentPath: "StoreManagement/ProductionStoreScan/ProductionStoreScanIndex" },
    { title: "采购订单", name: "PurchaseOrderList", componentPath: "StoreManagement/PurchaseOrder/PurchaseOrder" },
    { title: "采购订单明细", name: "PurchaseOrderDetailList", componentPath: "StoreManagement/PurchaseOrderDetail/PurchaseOrderDetail" },
    { title: "采购信息记录", name: "PurchaseInfoRecordList", componentPath: "StoreManagement/PurchaseInfoRecord/PurchaseInfoRecord" },
    { title: "设备档案", name: "EquipmentList", componentPath: "em/Equipment/EquipmentList", authIndex: 452 },
    { title: "设备维修", name: "EMRepairOrderList", componentPath: "em/EMRepairOrder/EMRepairOrderList", authIndex: 459 },
    { title: "日期维护", name: "DataList", componentPath: "em/EMRepairOrder/DataList", authIndex: 461 },
    { title: "维修子单", name: "EMRepairOrderDetailList", componentPath: "em/EMRepairOrderDetail/EMRepairOrderDetailList", authIndex: 457 },
  ]),
  // 基本信息(information)
  mainMenu("基本信息", "information", [
    { title: "客户管理", name: "CustomerList", componentPath: "information/Customer/CustomerList", authIndex: 100 },
    { title: "客户物料关系", name: "CustomerMaterialMappingList", componentPath: "information/CustomerMaterialMapping/CustomerMaterialMappingList", authIndex: 106 },
    { title: "供应商管理", name: "SupplierManageList", componentPath: "information/SupplierManage/SupplierManageList", authIndex: 111 },
    { title: "部门管理", name: "DepartmentList", componentPath: "information/Department/DepartmentList", authIndex: 113 },
    { title: "员工管理", name: "EmployeeList", componentPath: "information/Employee/EmployeeList", authIndex: 118 },
    { title: "物料管理", name: "MaterialList", componentPath: "information/Material/MaterialList", authIndex: 123 },
    { title: "物料类型管理", name: "MaterialTypeNameTree", componentPath: "information/MaterialTypeName/MaterialTypeNameTree" },
    { title: "BOM管理", name: "BomManageList", componentPath: "information/BomManage/BomList", authIndex: 134 },
    { title: "计量单位管理", name: "UnitList", componentPath: "information/Unit/UnitList" },
    { title: "条码规则管理", name: "BarCodeRulesList", componentPath: "information/BarCodeRules/BarCodeRulesList", authIndex: 147 },
    { title: "客户条码管理", name: "CustomerSnRuleList", componentPath: "information/CustomerSnRule/CustomerSnRuleList", authIndex: 152 },
    { title: "物料条码管理", name: "MaterialSnRuleList", componentPath: "information/MaterialSnRule/MaterialSnRuleList", authIndex: 152 },
    { title: "区域管理", name: "DistrictList", componentPath: "information/District/DistrictList", authIndex: 157 },
    { title: "工厂管理", name: "FactoryList", componentPath: "information/Factory/FactoryList", authIndex: 162 },
    { title: "车间管理", name: "WorkShopList", componentPath: "information/WorkShop/WorkShopList", authIndex: 168 },
    { title: "工作中心管理", name: "WorkCenterList", componentPath: "information/WorkCenter/WorkCenterList", authIndex: 174 },
    { title: "工作单元管理", name: "WorkUnitManagementList", componentPath: "information/WorkUnit/WorkUnitList", authIndex: 180 },
    { title: "技能管理", name: "SkillList", componentPath: "information/Skill/SkillList" },
    { title: "ESOP管理", name: "EsopList", componentPath: "information/Esop/EsopList", authIndex: 192 },
    { title: "ESOP变更记录", name: "EsopChangeList", componentPath: "information/EsopChange/EsopChangeList", authIndex: 504 },
    { title: "文档管理", name: "FileManageList", componentPath: "information/FileManagement/FileManageList", authIndex: 510 },
    { title: "工序类型管理", name: "ProcessTypeManagementList", componentPath: "information/ProcessTypeManagement/ProcessTypeList", authIndex: 199 },
    { title: "工序管理", name: "ProcedureList", componentPath: "information/Procedure/ProcedureList", authIndex: 205 },
    { title: "工艺路线管理", name: "RtRouteList", componentPath: "information/RtRoute/RtRouteList", authIndex: 212 },
    { title: "产品工艺管理", name: "RtRouteMaterialList", componentPath: "information/RtRouteMaterial/RtRouteMaterialList", authIndex: 219 },
    { title: "仓库配置", name: "WarehouseNewList", componentPath: "information/WarehouseNew/WarehouseList", authIndex: 227 },
    { title: "库区配置", name: "WarehouseAreaList", componentPath: "information/WarehouseArea/WarehouseAreaList", authIndex: 901 },
    { title: "仓位配置", name: "WarehouseLocationList", componentPath: "information/WarehouseLocation/WarehouseLocationList", authIndex: 951 },
    { title: "载具配置", name: "VehicleList", componentPath: "information/Vehicle/VehicleList" },
    { title: "班组管理", name: "WorkerGroupList", componentPath: "information/WorkerGroup/WorkerGroupList" },
    { title: "项目管理", name: "ProjectManagementList", componentPath: "information/ProjectManagement/ProjectList" },
    { title: "任务管理", name: "TaskManagementList", componentPath: "information/TaskManagement/TaskList", authIndex: 335 },
    { title: "ERP数据管理", name: "ErpIndex", componentPath: "information/ERP/ErpOrderManage", authIndex: 431 },
  ]),
  // 系统管理(SystemInfo)
  mainMenu("系统管理", "SystemInfo", [
    { title: "角色管理", name: "RoleList", componentPath: "SystemInfo/role/RoleList", authIndex: 253 },
    { title: "表单分配", name: "WfConfigList", componentPath: "SystemInfo/WfConfig/WFConfigList", authIndex: 477 },
    { title: "用户管理", name: "UserList", componentPath: "SystemInfo/SystemUser/UserList", authIndex: 258 },
    { title: "个人信息", name: "ProfilesList", componentPath: "SystemInfo/profiles/ProfilesList", authIndex: 263 },
    { title: "菜单管理", name: "SystemFunctionTree", componentPath: "SystemInfo/systemFunction/SystemFunctionTree" },
    { title: "系统字典", name: "SystemDictionaryList", componentPath: "SystemInfo/systemDictionary/SystemDictionaryList", authIndex: 270 },
    { title: "客户环境配置", name: "CustomerEnvironmentConfigurationList", componentPath: "SystemInfo/CustomerEnvironmentConfiguration/CustomerEnvironmentConfigurationList", authIndex: 275},
    { title: "编码规则", name: "EncodingRulesList", componentPath: "SystemInfo/EncodingRules/EncodingRulesList", authIndex: 280 },
  ]),
  // 看板管理
  mainMenu("看板管理", "Spectaculars", [
    { title: "生产看板", name: "Productpectaculars", componentPath: "Spectaculars/Productpectaculars", authIndex: 502 },
    { title: "车间看板1", name: "Kb1", componentPath: "Spectaculars/Kb1", authIndex: 502 },
    { title: "车间看板2", name: "Kb2", componentPath: "Spectaculars/Kb2", authIndex: 502 },
    { title: "车间看板3", name: "Kb3", componentPath: "Spectaculars/Kb3", authIndex: 502 },
    { title: "车间看板4", name: "Kb4", componentPath: "Spectaculars/Kb4", authIndex: 502 },
    { title: "仓库看板", name: "Kb5", componentPath: "Spectaculars/Kb5", authIndex: 502 },
    { title: "仓库收发料看板", name: "Kb6", componentPath: "Spectaculars/Kb6", authIndex: 502 },
  ]),
  mainMenu("表单管理", "FormManagement", [
    { title: "新产品申请", name: "ProductApplicationList", componentPath: "fm/ProductionApplication/ProductionApplicationList", authIndex: 237 },
    { title: "供应商申请", name: "SupplierApplicationList", componentPath: "fm/SupplierApplication/SupplierApplicationList", authIndex: 647 },
 ]),
];

const router = new Router({
  base: process.env.BASE_URL,
  routes: routes,
});

const whiteUris = ["/login"]; // 白名单,无需登录即可访问

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path.indexOf("/kb/") !== -1 || whiteUris.indexOf(to.path) !== -1 || loginUtil.isLogin()) {
    // 在白名单当中或者已经登录,放行
    next();
  } else {
    toLogin(to.fullPath);
  }
});

router.afterEach(() => {
  NProgress.done();
});

export const toLogin = () => {
  router.push({
    path: "/login",
  });
};

export { routes };
export default router;
